import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { DateService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-group-date-picker-dialog',
  templateUrl: './group-date-picker-dialog.component.html',
  styleUrls: ['./group-date-picker-dialog.component.scss'],
  providers: [DialogService],
})
export class GroupDatePickerDialogComponent implements OnInit {
  startDate: any = new Date();
  endDate: any = new Date();
  maxStartDateRange: any = new Date();
  maxEndDateRange: any = new Date();
  id: string = '';
  path: string = '';
  type: string = '';
  filter: any = {};
  selectedDateTitle: string = '';
  hasAttendanceDate: boolean = false;
  isEndDatePickerOnly: boolean = false;
  dateFormat = 'mm/yyyy';
  viewMode = 'date';
  endDateTitle = 'End date';
  isCustomMonth = false;

  constructor(
    public ref: DynamicDialogRef,
    private dateService: DateService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private location: Location,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    const { startDate, endDate, currentDate, hasScheduledFollowups, id, hasAttendanceDate, filter, path, type, selectedDateTitle, isEndDatePickerOnly, isCustomMonth = false } = this.dynamicDialogConfig.data;
    this.startDate = new Date(`${startDate}T00:00:00`);
    this.endDate = new Date(`${endDate}T00:00:00`);
    const attendaceMaxEndDate = this.dateService.addDaysInDatetime(startDate, 31, 'day', datetimeFormat.yyymmdd);
    this.maxStartDateRange = hasScheduledFollowups ? '' : new Date(currentDate);
    this.maxEndDateRange = hasScheduledFollowups ? '' : hasAttendanceDate ? new Date(attendaceMaxEndDate) : new Date(currentDate);
    this.id = id;
    this.path = path;
    this.type = type;
    this.filter = filter;
    this.selectedDateTitle = selectedDateTitle;
    this.hasAttendanceDate = hasAttendanceDate;
    // this.isEndDatePickerOnly? 'End date' : 'Custom date'
    this.isEndDatePickerOnly = isEndDatePickerOnly;
    if (this.isEndDatePickerOnly) {
      this.endDateTitle = 'Custom date';
    }
    if (isCustomMonth) {
      this.isCustomMonth = true;
      this.endDateTitle = 'Select Month and year';
      this.viewMode = 'month';
      this.dateFormat = 'mm/yy';
    }
  }

  handleStartDateChange(startDate) {
    this.startDate = new Date(startDate);
    if (this.hasAttendanceDate) {
      const sDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
      this.maxEndDateRange = new Date(this.dateService.addDaysInDatetime(sDate, 31, 'day', datetimeFormat.yyymmdd));
    }
    this.updateUrl()
  }

  handleEndDateChange(endDate: string) {
    this.endDate = new Date(endDate);
    
    if (this.isCustomMonth) {
      this.startDate = new Date(endDate);
      this.endDate = this.getEndOfMonth(new Date(endDate));
      this.updateUrl();
      
      this.ref.close({
        isSuccess: true,
        startDate: this.dateService.formatDate(this.startDate, datetimeFormat.yyymmdd),
        endDate: this.dateService.formatDate(this.endDate, datetimeFormat.yyymmdd),
      })
    }
    else if (this.isEndDatePickerOnly) {
      this.ref.close({
        isSuccess: true,
        startDate: null,
        endDate: this.dateService.formatDate(this.endDate, datetimeFormat.yyymmdd),
      });
    }

    this.ref.close({
      isSuccess: true,
      startDate: this.dateService.formatDate(this.startDate, datetimeFormat.yyymmdd),
      endDate: this.dateService.formatDate(this.endDate, datetimeFormat.yyymmdd),
    });
    this.updateUrl()
  }

  updateUrl() {
    const startDate = this.dateService.formatDate(this.startDate, datetimeFormat.yyymmdd);
    const endDate = this.dateService.formatDate(this.endDate, datetimeFormat.yyymmdd);

    if (
      [
        '/reports/business-summary-report',
        '/reports/sales',
        '/reports/profitability',
        '/reports/service-invoiced',
        '/reports/canned-service-detail',
        '/reports/labor-reporting-drill-down',
        '/reports/supplier-detail',
        '/reports/technician-summary',
        '/reports/technician-summary-all-service-details',
        '/reports/customers',
        '/reports/labor-reporting',
        '/reports/sold-report',
        '/reports/fee-report',
        '/reports/discount-reporting',
        '/reports/google-review',
        '/reports/orders',
        '/reports/outstandinginvoice',
        '/reports/orderarbycustomer',
        '/reports/inventory-activity-reports',
        '/reports/inventory-level-reports',
        '/reports/unused-inventory',
        '/reports/warranties-report',
        '/reports/all-payments',
        '/reports/daily-report',
        '/reports/end-day-cash-drawer',
        '/reports/taxes',
        '/reports/sales-tax-item',
        '/reports/supplier-summary',
        '/reports/acc-payable-supplier',
        '/reports/technician-activity-records',
        '/reports/technician-summary',
        'reports/technician-summary-all-service',
        '/reports/technician-attendance-log',
        '/reports/fee-report',
        '/reports/sold-report',
        '/reports/discount-reporting',
        '/reports/supplier-summary',
        '/reports/drill-down-report',
        '/reports/discount-drill-down-report',
        '/reports/end-day-cash-drawer',
        '/reports/sales-tax-item',
        '/reports/commission-summary',
        '/reports/royalty',
      ].includes(this.path)
    ) {
      this.location.replaceState(`${this.path}/${startDate}/${endDate}`);
    } else if (this.path === `/reports/tax-rates/{this.activatedRoute.snapshot.paramMap.get('taxRateId') }`) {
      const taxRateId = this.activatedRoute.snapshot.paramMap.get('taxRateId');
      this.location.replaceState(`/reports/tax-rates/${this.selectedDateTitle}/${taxRateId || 'unassigned'}/${startDate}/${endDate}`);
    } else if (this.path === '/reports/fee-drill-down-report') {
      this.location.replaceState(`${this.path}/${this.type}/${startDate}/${endDate}/${this.selectedDateTitle}/${this.filter.title}`);
    } else if (this.path === '/reports/labor-reporting-drill-down') {
      this.location.replaceState(`${this.path}/${startDate}/${endDate}/${this.filter.title}`);
    } else if (this.path === '/reports/canned-service-detail' && this.filter.title) {
      this.location.replaceState(`${this.path}/${startDate}/${endDate}/${this.selectedDateTitle}/${this.filter.title}`);
    } else if (this.path === '/reports/supplier-detail') {
      this.location.replaceState(`${this.path}/${startDate}/${endDate}/${this.selectedDateTitle}/${this.filter.title}`);
    } else if (this.path === '/reports/technician-detail') {
      this.location.replaceState(`${this.path}/${startDate}/${endDate}/${this.selectedDateTitle}/${this.filter.title}`);
    } else if (this.path === '/reports/tax-detail') {
      this.location.replaceState(`${this.path}/${startDate}/${endDate}/${this.selectedDateTitle}/${this.filter.title}`);
    }
  }

  closeModal() {
    this.ref.close({
      isSuccess: false,
    });
  }

  getEndOfMonth(date: Date): Date {
    const year = date.getFullYear();
    const month = date.getMonth(); // Note: getMonth() is 0-indexed (January is 0)

    // Set date to the last day of the month
    return new Date(year, month + 1, 0);
  }
}
